<template>
<div class="file-upload">
    <input type="file" ref="file" multiple="multiple">
    <br>
    <span v-if="error_f" class="text-danger">Please select files to upload</span>
    <a class="gobtn" @click="submitFiles()" id='button' style="float:right;">Upload</a>
</div>
</template>

<script>
// import fileupload from '../services/fileupload'
import api from '../services/api'
import ls from '../services/ls'
export default {
    name: 'fileupload',
    props: ['UploadProps'],
    data: function () {
        return {
            path: process.env.VUE_APP_FILE_PATH + 'accounting/93a78fda576cda1c450253b384d4184cconsent_singlepage.pdf',
            percentCompleted: 0,
            error_f:false
        }
    },
    methods: {
        submitFiles() {
            this.error_f=false;
            let formData = new FormData();
            for (var i = 0; i < this.$refs.file.files.length; i++) {
                let file = this.$refs.file.files[i];
                console.log(file);
                formData.append('files[' + i + ']', file);
            }
            formData.append('subscription_id', this.UploadProps.subscription_id)
            formData.append('slug', this.UploadProps.subscription_type)
            formData.append('folder_id', this.UploadProps.folder_id)
            formData.append('session_user', ls.get('_u_unique'));
            if(!this.$refs.file.files.length){
                this.error_f=true;
                return false;
            }
            api.post('files/upload', formData)
                .then( res=> {
                   this.$emit('Newlist',res.data)
                    // this.$emit("closeModal", true);
                })
                .catch(function () {});
                this.$emit("closeModal", true);
        },
       
    },
    created() {

    }
}
</script>
